(function () {
	"use strict";

	if (typeof document === "undefined") return;

	var COOKIE_NAME =
		window.bds_theme.features.cookie_consent.cookie_name ||
		"bds_cookie_consent";
	var COOKIE_EXPIRES =
		window.bds_theme.features.cookie_consent.expires || 365;

	// Helper to execute code from a string, handling <script src="..."> and inline scripts
	function executeScript(code) {
		if (!code) return;

		// Match all <script> tags (with or without src)
		var scriptRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
		var match;
		var scripts = [];

		while ((match = scriptRegex.exec(code))) {
			var attrs = match[1];
			var inlineCode = match[2];
			var srcMatch = attrs.match(/src=["']([^"']+)["']/i);

			if (srcMatch) {
				// External script
				var scriptEl = document.createElement("script");
				scriptEl.async = attrs.includes("async");
				scriptEl.src = srcMatch[1];
				document.head.appendChild(scriptEl);

				// If there's inline code, run it after the script loads
				if (inlineCode.trim()) {
					scriptEl.onload = function () {
						try {
							new Function(inlineCode)();
						} catch (e) {
							console.warn(
								"Error executing inline script after src",
								e,
							);
						}
					};
				}
			} else if (inlineCode.trim()) {
				// Inline script only
				try {
					new Function(inlineCode)();
				} catch (e) {
					console.warn("Error executing inline script", e);
				}
			}
		}

		// Remove all <script> tags and run any remaining code (for legacy support)
		var cleaned = code.replace(scriptRegex, "");
		if (cleaned.trim()) {
			try {
				new Function(cleaned)();
			} catch (e) {
				console.warn("Error executing non-script code", e);
			}
		}
	}

	function setCookie(name, value, days) {
		var expires = "";
		if (typeof days === "number") {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie =
			name +
			"=" +
			encodeURIComponent(value) +
			expires +
			"; path=/; SameSite=Lax";
	}

	function getCookie(name) {
		var match = document.cookie.match(
			new RegExp("(^| )" + name + "=([^;]+)"),
		);
		return match ? decodeURIComponent(match[2]) : null;
	}

	function parseConsent(raw) {
		try {
			return raw ? JSON.parse(raw) : null;
		} catch (e) {
			return null;
		}
	}

	function saveConsent(consentObj) {
		setCookie(COOKIE_NAME, JSON.stringify(consentObj), COOKIE_EXPIRES);
	}

	document.addEventListener("DOMContentLoaded", function () {
		var banner = document.querySelector(".bds-cookie-consent");
		var consentRaw = getCookie(COOKIE_NAME);
		var consent = parseConsent(consentRaw);

		var onAcceptScript =
			window.bds_theme.features.cookie_consent.on_accept || "";
		var onRejectScript =
			window.bds_theme.features.cookie_consent.on_reject || "";

		// If consent exists, don't show banner and apply consent immediately.
		if (consent) {
			if (banner) banner.style.display = "none";

			if (consent.analytics) {
				executeScript(onAcceptScript);
			} else {
				executeScript(onRejectScript);
			}
		} else {
			if (banner) {
				banner.style.display = "block";
				setTimeout(function () {
					banner.classList.add("active");
				}, 10);
			}
		}

		var btnDismiss = document.querySelector(".bds-cookie-consent__dismiss");
		var btnReject = document.querySelector(".bds-cookie-consent__reject");

		if (btnDismiss) {
			btnDismiss.addEventListener("click", function () {
				var allConsent = { essential: true, analytics: true };
				saveConsent(allConsent);

				if (banner) {
					banner.classList.remove("active");
					banner.addEventListener(
						"transitionend",
						function handler(e) {
							if (e.propertyName === "opacity") {
								banner.removeEventListener(
									"transitionend",
									handler,
								);
								if (banner.parentNode) {
									banner.parentNode.removeChild(banner);
								}
							}
						},
					);
				}
				executeScript(onAcceptScript);
			});
		}

		if (btnReject) {
			btnReject.addEventListener("click", function () {
				var rejectConsent = { essential: true, analytics: false };
				saveConsent(rejectConsent);

				if (banner) {
					banner.classList.remove("active");
					banner.addEventListener(
						"transitionend",
						function handler(e) {
							if (e.propertyName === "opacity") {
								banner.removeEventListener(
									"transitionend",
									handler,
								);
								if (banner.parentNode) {
									banner.parentNode.removeChild(banner);
								}
							}
						},
					);
				}
				executeScript(onRejectScript);
			});
		}
	});
})();
